import React from "react";
import { HomeContainer } from "./style.js";
const Home = () => {
  return <HomeContainer></HomeContainer>;
};
export default Home;
